<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import SelectOptions from "@/components/tipologia-immobile-options";
import axios from "axios";
import Lottie from "@/components/widgets/lottie.vue";
import animationSuccess from "@/components/widgets/Animation-1701822503345.json";
import animationFailure from "@/components/widgets/Animation-1701855501291_grande.json";

export default {
    components: {
        Lottie,
        Multiselect,
        SelectOptions,
    },
    props: {
        isNewsletterMode: {
            type: Boolean,
            default: false
        },
        searchQuery: String,
        selectedCities: {
            type: Array,
            default: () => [] // Ensures default is an empty array
        },
        cityOptions: Array,
        immobileTipologia: String,
        immobileCategoria: String,
        minPrice: Number,
        maxPrice: Number,
        filterNoPrice: Boolean,
        minLocali: Number,
        maxLocali: Number,
        minAnnoCostruzione: Number,
        maxAnnoCostruzione: Number,
        minSuperficie: Number,
        maxSuperficie: Number,
        rentSale: String,
        qrCodes: Array
    },
    data() {
        return {
            schermataFiltroModal: false,
            saveSearchModal: false,
            successModal: false,
            errorModal: false,
            succesOptions: { animationData: animationSuccess },
            failureOptions: { animationData: animationFailure },
            email: "",
            nome: "",
            cognome: "",
            privacyChecked: false,
            isSubscribed: false,
            saveSearchCities: [],
            allSwitzerlandCities: [],
        };
    },
    computed: {
        isFilterValid() {
            return this.isRangeValid(this.minPrice, this.maxPrice) && this.isRangeValid(this.minLocali, this.maxLocali) &&
                this.isRangeValid(this.minAnnoCostruzione, this.maxAnnoCostruzione) && this.isRangeValid(this.minSuperficie, this.maxSuperficie);
        },
        privacyPolicyUrl() {
            return this.$router.resolve({ name: 'privacy-policy' }).href;
        },
        sortedCityOptions() {
            return this.getUniqueCityOptions().slice().sort((a, b) => a.localeCompare(b));
        }
    },
    methods: {
        async fetchSubscriptionStatus() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/check-authentication/`);
                this.isSubscribed = response.data.status === 'authenticated';
                console.log("Subscription status fetched successfully:", response.data);
                return this.isSubscribed;
            } catch (error) {
                console.error('Error fetching subscription status:', error);
                return false;
            }
        },
        async fetchAllCities() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/get-cities/`);
                this.allSwitzerlandCities = response.data.sort((a, b) => a.localeCompare(b));
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        },
        emitFilter() {
            this.schermataFiltroModal = false;
            this.$emit('onFilter', {
                searchQuery: this.searchQuery,
                selectedCities: this.selectedCities,
                immobileTipologia: this.immobileTipologia,
                immobileCategoria: this.immobileCategoria,
                minPrice: this.minPrice,
                maxPrice: this.maxPrice,
                filterNoPrice: this.filterNoPrice,
                minLocali: this.minLocali,
                maxLocali: this.maxLocali,
                minAnnoCostruzione: this.minAnnoCostruzione,
                maxAnnoCostruzione: this.maxAnnoCostruzione,
                minSuperficie: this.minSuperficie,
                maxSuperficie: this.maxSuperficie,
                rentSale: this.rentSale,
                qrCodes: this.qrCodes
            });
        },
        isRangeValid(min, max, value = null) {
            min = min !== '' ? min : null;
            max = max !== '' ? max : null;
            if (min === null && max === null) {
                return true;
            }
            if (min !== null && max === null) {
                return value === null || value >= min;
            }
            if (min === null && max !== null) {
                return value === null || value <= max;
            }
            if (min !== null && max !== null) {
                if (min > max) {
                    return false;
                } else {
                    return value === null || (value >= min && value <= max);
                }
            }
        },
        resetFilters() {
            this.$emit('update:selectedCities', []);
            this.$emit('update:immobileTipologia', '');
            this.$emit('update:immobileCategoria', '');
            this.$emit('update:rentSale', '');
            this.$emit('update:minPrice', null);
            this.$emit('update:maxPrice', null);
            this.$emit('update:filterNoPrice', false);
            this.$emit('update:minLocali', null);
            this.$emit('update:maxLocali', null);
            this.$emit('update:minAnnoCostruzione', null);
            this.$emit('update:maxAnnoCostruzione', null);
            this.$emit('update:minSuperficie', null);
            this.$emit('update:maxSuperficie', null);
            this.filteredQrCodes = this.qrCodes; // Reset to show all again
        },
        mostraSchermataFiltro() {
            this.schermataFiltroModal = true;
        },
        mostraSalvaRicerca() {
            this.saveSearchModal = true;
            this.saveSearchCities = this.selectedCities.slice();
        },
        async iscrivi() {
            try {
                console.log('Selected Cities:', this.saveSearchCities); // Adjusted to log saveSearchCities
                console.log('Immobile Tipologia:', this.immobileTipologia);
                console.log('Immobile Categoria:', this.immobileCategoria);
                console.log('Min Price:', this.minPrice);
                console.log('Max Price:', this.maxPrice);
                console.log('Filter No Price:', this.filterNoPrice);
                console.log('Min Locali:', this.minLocali);
                console.log('Max Locali:', this.maxLocali);
                console.log('Min Anno Costruzione:', this.minAnnoCostruzione);
                console.log('Max Anno Costruzione:', this.maxAnnoCostruzione);
                console.log('Min Superficie:', this.minSuperficie);
                console.log('Max Superficie:', this.maxSuperficie);
                console.log('Rent Sale:', this.rentSale);

                await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/post-subscription/`, {
                    email: this.email,
                    nome: this.nome,
                    cognome: this.cognome,
                    selected_cities: this.saveSearchCities, // Adjusted to send saveSearchCities
                    immobile_tipologia: this.immobileTipologia,
                    immobile_categoria: this.immobileCategoria,
                    min_price: this.minPrice,
                    max_price: this.maxPrice,
                    filter_no_price: this.filterNoPrice,
                    min_locali: this.minLocali,
                    max_locali: this.maxLocali,
                    min_anno_costruzione: this.minAnnoCostruzione,
                    max_anno_costruzione: this.maxAnnoCostruzione,
                    min_superficie: this.minSuperficie,
                    max_superficie: this.maxSuperficie,
                    rent_sale: this.rentSale,
                });
                this.saveSearchModal = false;
                this.successModal = true;
            } catch (error) {
                console.error('Error during subscription:', error);
                this.errorModal = true;
            }
        },
        getUniqueCityOptions() {
            const uniqueCities = new Set(this.cityOptions.map(city => city.toLowerCase()));
            return Array.from(uniqueCities).map(city => {
                return this.cityOptions.find(option => option.toLowerCase() === city);
            });
        }
    },
    async mounted() {
        await this.fetchSubscriptionStatus();
        await this.fetchAllCities();
    }
};
</script>

<template>
    <BRow style="padding: 15px; max-width: 900px; margin: 0 auto; align-items: center;" v-if="!isNewsletterMode">
        <BCol class="col-12 col-md">
            <div class="search-box d-flex align-items-center">
                <input type="text" class="form-control search" :value="searchQuery" @input="$emit('update:searchQuery', $event.target.value)" placeholder="Ricerca..." />
                <i class="ri-search-line search-icon"></i>
            </div>
        </BCol>
        <BCol class="col-12 col-md-auto d-flex flex-column flex-md-row justify-content-md-end align-items-md-center mt-2 mt-md-0">
            <div class="btn-group me-2 d-flex align-items-center" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" class="btn-check" name="rentSaleOptions" id="tutti" value="" :checked="rentSale === ''" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                <label :class="['btn', 'rounded', rentSale === '' ? 'btn-info' : 'btn-outline-info-white']" for="tutti" style="margin-bottom: 0;">Tutti</label>
                <input type="radio" class="btn-check" name="rentSaleOptions" id="affitto" value="Affitto" :checked="rentSale === 'Affitto'" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                <label :class="['btn', 'rounded', rentSale === 'Affitto' ? 'btn-info' : 'btn-outline-info-white']" for="affitto" style="margin-bottom: 0;">Affitto</label>
                <input type="radio" class="btn-check" name="rentSaleOptions" id="vendita" value="Vendita" :checked="rentSale === 'Vendita'" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                <label :class="['btn', 'rounded', rentSale === 'Vendita' ? 'btn-info' : 'btn-outline-info-white']" for="vendita" style="margin-bottom: 0;">Vendita</label>
            </div>
            <BButton variant="info" @click="mostraSchermataFiltro()"><i class="ri-filter-line"></i> {{ $t('filtri') }}</BButton>
            <BButton variant="info" class="mx-2" @click="emitFilter" :disabled="!isFilterValid"><i class="ri-search-line"></i> Cercare</BButton>
            <BButton variant="info" @click="mostraSalvaRicerca" :disabled="!isFilterValid"><i class="ri-notification-2-line"></i> {{ $t('salva-ricerca') }}</BButton>
        </BCol>
    </BRow>

    <b-modal v-model="schermataFiltroModal" id="schermataFiltroModal" hide-footer class="v-modal-custom" modal-class="zoomIn" centered>
        <div class="fs-15 d-flex justify-content-center align-items-center"><h4>{{ $t('filtri') }}</h4></div>
        <div>
            <div v-if="!isNewsletterMode" class="row mb-3">
                <label class="form-label">{{ $t('tipo') }}</label>
                <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                    <input type="radio" class="btn-check" name="modalRentSaleOptions" id="modal-tutti" value="" :checked="rentSale === ''" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                    <label for="modal-tutti" class="btn btn-outline-info rounded">Tutti</label>
                    <input type="radio" class="btn-check" name="modalRentSaleOptions" id="modal-affitto" value="Affitto" :checked="rentSale === 'Affitto'" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                    <label for="modal-affitto" class="btn btn-outline-info rounded">Affitto</label>
                    <input type="radio" class="btn-check" name="modalRentSaleOptions" id="modal-vendita" value="Vendita" :checked="rentSale === 'Vendita'" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                    <label for="modal-vendita" class="btn btn-outline-info rounded">Vendita</label>
                </div>
            </div>
            <div v-else class="row mb-3">
                <label class="form-label">{{ $t('tipo') }}</label>
                <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                    <input type="radio" class="btn-check" name="newsletterRentSaleOptions" id="newsletter-tutti" value="" :checked="rentSale === ''" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                    <label for="newsletter-tutti" class="btn btn-outline-info rounded">Tutti</label>
                    <input type="radio" class="btn-check" name="newsletterRentSaleOptions" id="newsletter-affitto" value="Affitto" :checked="rentSale === 'Affitto'" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                    <label for="newsletter-affitto" class="btn btn-outline-info rounded">Affitto</label>
                    <input type="radio" class="btn-check" name="newsletterRentSaleOptions" id="newsletter-vendita" value="Vendita" :checked="rentSale === 'Vendita'" @change="$emit('update:rentSale', $event.target.value)" autocomplete="off">
                    <label for="newsletter-vendita" class="btn btn-outline-info rounded">Vendita</label>
                </div>
            </div>
            <div class="mb-3">
                <label for="selectedCitiesLabel" class="form-label">Dove?</label>
                <Multiselect :modelValue="selectedCities" @update:modelValue="val => $emit('update:selectedCities', Array.isArray(val) ? val : [])" mode="tags" :options="sortedCityOptions" :multiple="true" placeholder="Seziona località"
                    label="city" track-by="city" :noResultsText="$t('nessunrisultatotrovato')" :close-on-select="false" :searchable="true" :allow-empty="false" />                       
            </div>
            <div v-if="isSubscribed" class="mb-3">
                <label for="selectedCategoria" class="form-label">Categoria</label>
                <select class="form-select mb-3" :value="immobileCategoria" @change="$emit('update:immobileCategoria', $event.target.value)" name="selectedCategoria" id="selectedCategoria">
                    <option value="">Seleziona categoria</option>
                    <option value="Terreno">Terreno</option>
                    <option value="Locale">Locale</option>
                    <option value="Stabile">Stabile</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="selectedTipologia" class="form-label">Tipologia</label>
                <select class="form-select mb-3" :value="immobileTipologia" @change="$emit('update:immobileTipologia', $event.target.value)" name="selectedTipologia" id="selectedTipologia"><SelectOptions /></select>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label for="minPrice" class="form-label">Prezzo Minimo</label>
                    <input type="number" id="minPrice" :value="minPrice" @input="$emit('update:minPrice', parseFloat($event.target.value))" class="form-control" :max="maxPrice || Infinity" placeholder="Minimo">
                </div>
                <div class="col-md-6">
                    <label for="maxPrice" class="form-label">Prezzo Massimo</label>
                    <input type="number" id="maxPrice" :value="maxPrice" @input="$emit('update:maxPrice', parseFloat($event.target.value))" class="form-control" :min="minPrice || 0" placeholder="Massimo">
                </div>
            </div>
            <div class="mb-3">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="filterNoPrice" :checked="filterNoPrice" @change="$emit('update:filterNoPrice', $event.target.checked)">
                    <label class="form-check-label" for="filterNoPrice">Escludi Immobili Senza Prezzo</label>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label for="minLocali" class="form-label">Locali Minimi</label>
                    <input type="number" id="minLocali" class="form-control" :value="minLocali" @input="$emit('update:minLocali', parseFloat($event.target.value))" min="1" :max="maxLocali || Infinity" placeholder="Minimo" step="0.5">
                </div>
                <div class="col-md-6">
                    <label for="maxLocali" class="form-label">Locali Massimi</label>
                    <input type="number" id="maxLocali" class="form-control" :value="maxLocali" @input="$emit('update:maxLocali', parseFloat($event.target.value))" :min="minLocali || 1" placeholder="Massimo" step="0.5">
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label for="minAnnoCostruzione" class="form-label">Anno Minimo</label>
                    <input type="number" id="minAnnoCostruzione" class="form-control" :value="minAnnoCostruzione" @input="$emit('update:minAnnoCostruzione', parseFloat($event.target.value))" :max="maxAnnoCostruzione || Infinity" placeholder="Minimo">
                </div>
                <div class="col-md-6">
                    <label for="maxAnnoCostruzione" class="form-label">Anno Massimo</label>
                    <input type="number" id="maxAnnoCostruzione" class="form-control" :value="maxAnnoCostruzione" @input="$emit('update:maxAnnoCostruzione', parseFloat($event.target.value))" :min="minAnnoCostruzione || 0" placeholder="Massimo">
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label for="minSuperficie" class="form-label">Superficie Minimo</label>
                    <input type="number" id="minSuperficie" class="form-control" :value="minSuperficie" @input="$emit('update:minSuperficie', parseFloat($event.target.value))" :max="maxSuperficie || Infinity" placeholder="Minimo">
                </div>
                <div class="col-md-6">
                    <label for="maxSuperficie" class="form-label">Superficie Massimo</label>
                    <input type="number" id="maxSuperficie" class="form-control" :value="maxSuperficie" @input="$emit('update:maxSuperficie', parseFloat($event.target.value))" :min="minSuperficie || 0" placeholder="Massimo">
                </div>
            </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
            <BButton variant="danger" @click="resetFilters">Reset</BButton>
            <BButton variant="light" @click="schermataFiltroModal = false">Annulla</BButton>
            <BButton variant="info" @click="emitFilter" :disabled="!isFilterValid" v-if="!isNewsletterMode"><i class="ri-search-line"></i> Cercare</BButton>
        </div>
        <div class="d-flex justify-content-center">
            <BButton variant="info" @click="mostraSalvaRicerca" :disabled="!isFilterValid"><i class="ri-notification-2-line"></i> {{ $t('salva-ricerca') }}</BButton>
        </div>
    </b-modal>
    <b-modal v-model="saveSearchModal" id="saveSearchModal" hide-footer class="v-modal-custom" modal-class="zoomIn" centered>
        <div class="fs-15 d-flex justify-content-center align-items-center">
            <h4>{{ $t('salva-ricerca') }}</h4>
        </div>
        <p>I filtri impostati in precedenza sono stati salvati. Completa le seguenti informazioni per ricevere un'avviso.</p>
        <div class="mb-3">
            <b-row>
                <b-col>
                    <label for="nome" class="form-label">Nome</label>
                    <input type="text" id="nome" v-model="nome" class="form-control" placeholder="Inserisci il tuo nome">
                </b-col>
                <b-col>
                    <label for="cognome" class="form-label">Cognome</label>
                    <input type="text" id="cognome" v-model="cognome" class="form-control" placeholder="Inserisci il tuo cognome">
                </b-col>
            </b-row>
        </div>
        <div class="mb-3">
            <label for="email" class="form-label">E-mail</label>
            <input type="email" id="email" v-model="email" class="form-control" placeholder="Inserisci la tua e-mail">
        </div>
        <div class="mb-3">
            <label for="saveSearchCitiesLabel" class="form-label">Dove?</label>
            <p>Seleziona le tue località preferite.</p>
            <Multiselect 
                v-model="saveSearchCities" mode="tags" 
                :options="allSwitzerlandCities"
                :multiple="true"
                placeholder="Seleziona località"
                label="city"
                track-by="city"
                :noResultsText="$t('nessunrisultatotrovato')"
                :close-on-select="false"
                :searchable="true"
                :allow-empty="false"
            />
        </div>
        <div class="mb-3">
            <b-form-checkbox v-model="privacyChecked" required>
                Autorizzo l'invio di comunicazioni relative alla mia richiesta 
                (<a :href="privacyPolicyUrl" target="_blank" class="text-info">Privacy & Policy</a>)
            </b-form-checkbox>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
            <BButton variant="light" @click="saveSearchModal = false">Annulla</BButton>
            <BButton :disabled="!privacyChecked" variant="info" @click="iscrivi">Salva</BButton>
        </div>
    </b-modal>

    <b-modal v-model="successModal" id="successModal" hide-footer class="v-modal-custom" modal-class="zoomIn" centered>
        <lottie colors="primary:#121331,secondary:#08a88a" trigger="loop" :options="succesOptions" :height="120" :width="120"/>
        <div class="fs-15 d-flex justify-content-center align-items-center"><h4>Ricerca salvata</h4></div>
        <div class="mb-3 d-flex justify-content-center">
            <p>Iscrizione avvenuta con successo!</p>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
            <BButton variant="info" @click="successModal = false">Chiudi</BButton>
        </div>
    </b-modal>
    <b-modal v-model="errorModal" id="errorModal" hide-footer class="v-modal-custom" modal-class="zoomIn" centered>
        <lottie :options="failureOptions" :height="120" :width="120"/>
        <div class="fs-15 d-flex justify-content-center align-items-center"><h4>Errore</h4></div>
        <div class="mb-3 d-flex justify-content-center">
            <p>Errore nell'iscrizione. Per favore riprova.</p>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
            <BButton variant="info" @click="errorModal = false">Chiudi</BButton>
        </div>
    </b-modal>
</template>

<style scoped>
.btn-outline-info-white {
  background-color: white;
  border-color: #17a2b8; /* Bootstrap info color */
  color: #17a2b8;
}

.btn-outline-info-white:hover {
  background-color: #e9ecef; /* Light gray for hover state */
  border-color: #17a2b8;
  color: #17a2b8;
}

@media (max-width: 767.98px) {
    .col-12.col-md-auto.d-flex.flex-column.flex-md-row.justify-content-md-end {
        align-items: center;
    }
    .col-12.col-md-auto.d-flex.flex-column.flex-md-row.justify-content-md-end > * {
        width: 100%;
        margin-bottom: 10px;
    }
    .col-12.col-md-auto.d-flex.flex-column.flex-md-row.justify-content-md-end > *:last-child {
        margin-bottom: 0;
    }
    .btn-group .btn {
        text-align: center;
        width: 100%;
    }
}
</style>